import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="page-container">
      <div className="bg-gradient h-full w-full !bg-white dark:!bg-intsamis-900">
        <div className="bg-image fixed h-screen w-screen"/>
        
        <FixedPlugin />
        <main className={`flex h-full mx-auto min-h-screen items-center justify-center`}>
          <div className="relative flex h-full">
            {/* <div className="mx-auto flex min-h-full w-full flex-col justify-center pt-12 md:max-w-[75%] lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:max-w-[1383px] xl:px-0 xl:pl-[70px]"> */}
            <div className="flex min-h-full w-full flex-col justify-center pt-8 lg:px-8 lg:pt-0 ">
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                </Routes>                
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
